import { createFileRoute } from '@tanstack/react-router'
import { GroupBookingsPage } from '@/features/hospitality/pages/GroupBookingsPage'

export const Route = createFileRoute('/_app/hospitality/group-bookings')({
  component: GroupBookingsPage,
})
